import { GoogleLogin } from "@react-oauth/google";
import Icons from "../../../components/icons";

const DEFAULT_UNAVAILABLE_MESSAGE =
  "Google sign in is temporarily unavailable. Please sign in with email and password.";

const decodeJwtPayload = (token) => {
  try {
    const payload = token.split(".")[1];
    const normalizedPayload = payload.replace(/-/g, "+").replace(/_/g, "/");
    const decodedPayload = window.atob(normalizedPayload);

    return JSON.parse(decodedPayload);
  } catch (error) {
    return null;
  }
};

const GoogleSignIn = ({
  buttonText,
  enabled = false,
  onSuccess,
  onUnavailable,
  unavailableMessage = DEFAULT_UNAVAILABLE_MESSAGE,
}) => {
  const handleUnavailable = () => {
    if (onUnavailable) {
      onUnavailable(unavailableMessage);
    }
  };

  if (!enabled) {
    return (
      <>
        <button
          className="border !border-[#D9D9D9] py-2 rounded-sm font-medium text-center w-full mt-8 bg-[#F5F5F5] !text-[#757575] cursor-not-allowed"
          type="button"
          onClick={handleUnavailable}
          aria-disabled="true"
        >
          <Icons id="googleworkspace" />
          <span className="ml-2.5">{buttonText}</span>
        </button>
        <p className="mt-3 text-sm text-[#757575]">{unavailableMessage}</p>
      </>
    );
  }

  return (
    <div className="mt-8 flex flex-col items-center gap-3">
      <GoogleLogin
        onSuccess={(credentialResponse) => {
          const googleCredential = credentialResponse?.credential;
          const payload = decodeJwtPayload(googleCredential || "");

          if (!googleCredential || !payload?.email) {
            handleUnavailable();
            return;
          }

          onSuccess?.({
            email: payload.email,
            ...(buttonText.includes('Sign up') && { userName: payload.name }),
            type: "google",
            googleCredential,
          });
        }}
        onError={handleUnavailable}
        text="signin_with"
        shape="rectangular"
        width="350"
      />
      <p className="text-sm text-[#757575]">
        Sign in with your verified Google account.
      </p>
    </div>
  );
};

export default GoogleSignIn;
